// extracted by mini-css-extract-plugin
export default {"taskWrapper":"task_taskWrapper__N+d2m"};